export default {
  methods: {
    setFilterParam(resourceName, key, value) {
      this.$store.commit('booleanSearch/SET_FILTER_PARAM', { key: resourceName, param: { key, value}})
    },

    resetPagination(resourceName) {
      this.$store.commit('booleanSearch/RESET_PAGINATION', resourceName)
    },

    resetPaginatedResource(resourceName) {
      this.$store.commit('booleanSearch/RESET_PAGINATED_RESOURCE', resourceName)
    }
  },
}